export { RecordVideoButton } from './RecordVideoButton';
export {
  type RecordVideoButtonProps,
  type MonkRecordVideoButtonProps,
} from './RecordVideoButton.types';
